(function (){
    "use strict";

    angular.module('swif.interventions')
        .controller('InterventionInvoicingController', InterventionInvoicingController);

    function InterventionInvoicingController ($scope, $q, swif) {
        'ngInject';
        // uom = unit of measure
        var prepareCostType = function (id, name, uom) {
            return {
                _id: id,
                name: name,
                description: '',
                cost: 0.0,
                lines: [],
                qty: 0,
                unit_price: 0.0,
                amount_total: 0.0,
                uom: uom || '',
                actions: []
            };
        };

        $scope.initialize = function () {
            $scope.hr = prepareCostType('hr', 'RH', 'h');
            $scope.equipments = prepareCostType('equipments', 'Equipements');
            $scope.consumables = prepareCostType('consumables', 'Fournitures');
            $scope.suppliers = prepareCostType('suppliers', 'Prestataires', 'h');
            $scope.misc = prepareCostType('misc', 'Autres');
            $scope.services = prepareCostType('services', 'Prestations');

            $scope.costTypes = [
                $scope.hr,
                $scope.equipments,
                $scope.consumables,
                $scope.suppliers,
                $scope.misc,
                $scope.services
            ];

            $scope.whole = {
                cost: 0,
                amount_total: 0
            };

        };

        $scope.computeLineTotal = function (costType) {
            costType.amount_total = costType.unit_price * (costType.qty || 1);
            $scope.computeWholeTotal();
        };

        $scope.setDefaultUnitPrice = function () {
            _.forEach($scope.costTypes, function (costType) {
                if (!costType.unit_price || costType.unit_price === 0) {
                    costType.unit_price = costType.cost / (costType.qty || 1);
                }
            });
        };

        $scope.costFetched = false;

        $scope.getCosts = function () {
            if (!$scope.costFetched) {
                $q.all([
                        $scope.fetchHrCosts(),
                        $scope.fetchEquipmentsCosts(),
                        $scope.fetchConsumablesCosts(),
                        $scope.fetchSuppliersCosts()
                    ]
                ).then(
                    function () {
                        $scope.computeWholeCost();
                    }
                );
                $scope.costFetched = true;
            }
        };

        $scope.fetchHrCosts = function () {
            var filter = {fields: ['user_id', 'cost', 'unit_cost', 'hours']};
            swif.data.addFilter(filter, 'task_id.project_id', '=', $scope.model.id);
            swif.data.addFilter(filter, 'user_id', '!=', false);
            // TOFIX: hotfix for report_hours modal workaround:
            // when setting a partner_id, we save the user_id too (should be removed from written fields)
            swif.data.addFilter(filter, 'partner_id', '=', false);
            return swif.data.get('work', undefined, filter).then(function (data) {
                $scope.hr.lines = data;
                $scope.computeData($scope.hr, 'cost', 'hours');
                return true;
            });
        };

        $scope.fetchEquipmentsCosts = function () {
            var filter = {fields: ['equipment_ids', 'effective_hours']};
            swif.data.addFilter(filter, 'project_id', '=', $scope.model.id);
            return swif.data.get('task', undefined, filter)
                .then(function (data) {
                    var eqFilter = {fields: ['hour_price', 'name', 'is_vehicle']};
                    return swif.data.get('equipment', undefined, eqFilter).then(function (eqData) {
                        var lines = [];
                        _.forEach(data, function (task) {
                            _.forEach(task.equipment_ids, function (eqId) {
                                var eq = _.find(eqData, {id: eqId});
                                if (eq) {
                                    _.merge(eq, task);
                                    eq.task_cost = eq.hour_price * task.effective_hours;
                                    lines.push(eq);
                                }
                            });
                        });
                        $scope.equipments.lines = lines;
                        $scope.computeData($scope.equipments, 'task_cost');
                        return true;
                    });
                });
        };

        $scope.fetchConsumablesCosts = function () {
            var filter = {fields: ['consumable_id', 'quantity', 'unit_price']};
            // var filter = {fields: ['consumable_id', 'quantity', 'unit_price', 'purchase_order_name']};
            swif.data.addFilter(filter, 'work_id.task_id.project_id', '=', $scope.model.id);
            return swif.data.get('consumed', undefined, filter).then(function (data) {
                _.forEach(data, function (line) {
                    line.amount_total = line.unit_price * line.quantity;
                });
                $scope.consumables.lines = data;
                $scope.computeData($scope.consumables, 'amount_total');
                return true;
            });
        };

        $scope.fetchSuppliersCosts = function () {
            var filter = {fields: ['partner_id', 'cost', 'hours']};
            swif.data.addFilter(filter, 'task_id.project_id', '=', $scope.model.id);
            swif.data.addFilter(filter, 'partner_id', '!=', false);
            return swif.data.get('work', undefined, filter).then(function (data) {
                $scope.suppliers.lines = data;
                $scope.computeData($scope.suppliers, 'cost', 'hours');
                return true;
            });
        };

        // sum the costs, sum the unit_prices, join the names, etc....
        $scope.computeData = function (costType, costLineField, qtyLineField) {
            _.forEach(costType.lines, function (line) {
                if (costLineField) {
                    costType.cost += line[costLineField];
                }
                if (qtyLineField) {
                    costType.qty += line[qtyLineField];
                }
            });
            $scope.computeLineTotal(costType);
        };

        $scope.computeWholeCost = function () {
            var cost = 0;
            _.forEach($scope.costTypes, function (costType) {
                cost += costType.cost || 0;
            });
            $scope.whole.cost = cost;
        };

        $scope.computeWholeTotal = function () {
            var total = 0;
            _.forEach($scope.costTypes, function (costType) {
                total += costType.amount_total || 0;
            });
            $scope.whole.amount_total = total;
        };

        $scope.initialize();
    }

})();
